import React from 'react';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import SmoothScrollLayout from './components/SmoothScrollLayout';
import SpaceCanvas from './components/canvas/SpaceCanvas';
import HTMLOverlay from './components/ui/HTMLOverlay';
import NavigationCapsule from './components/ui/NavigationCapsule';
import SpatialHUD from './components/ui/SpatialHUD';
import CosmicLoader from './components/ui/CosmicLoader';

function App() {
  return (
    <ThemeProvider>
      {/* 1. Cinematic Loading Screen & Texture Cache Pre-warmer */}
      <CosmicLoader />

      <SmoothScrollLayout>
        {/* 2. Fixed 3D Canvas — stays in viewport as user travels */}
        <div className="space-canvas-container">
          <SpaceCanvas />
        </div>

        {/* 3. HTML Spatial Overlay — Fixed single-project stages */}
        <HTMLOverlay />

        {/* 4. Fixed UI Navigation Capsule & Spatial HUD */}
        <NavigationCapsule />
        <SpatialHUD />
      </SmoothScrollLayout>
    </ThemeProvider>
  );
}

export default App;
